import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../Containers/Config/index.js';
import { GET_DASHBOARD, GET_DASHBOARD_SUCCESS, GET_DASHBOARD_ERROR } from '../actions';
import apiCall from '../../apiCall';

function* getV2Dashboard({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-dashboard-data`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_DASHBOARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DASHBOARD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_ERROR, payload: error });
  }
}

export function* watchV2Dashboard() {
  yield takeEvery(GET_DASHBOARD, getV2Dashboard);
}

function* watchV2DashboardSaga() {
  yield all([fork(watchV2Dashboard)]);
}

export default watchV2DashboardSaga;
